import React from "react";
import AddAndUpdatePerformance from "./AddAndUpdatePerformance";

const UpdatePerformance = () => {
  return <AddAndUpdatePerformance isUpdate={true} />;
};

export default UpdatePerformance;
